import AccountMonthSelectionScreen from 'features/statementsAndForms/screens/AccountStatements/AccountMonthSelectionScreen';
import React from 'react';

export default function AccountMonthSelectionScreenPage() {
  return <AccountMonthSelectionScreen />;
}
